import React from 'react'
import logoOnly from '../../../../../img/reggora/logo-only.png'
import logoText from '../../../../../img/reggora/logo-text.png'
import classNames from 'classnames'

export default function ReggoraLogo({ containerClassName }) {
  return (
    <div className={classNames('reggora-logo-container', containerClassName)}>
      <img src={logoOnly} alt="Reggora logo" className='reggora-logo-only' />
      <img src={logoText} alt="Reggora logo text" className='reggora-logo-text' />
    </div>
  )
}
